module.exports = __webpack_public_path__ + "static/media/move.c30d6bcc.png";